<ng-container *ngIf="options$ | async">
	<form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="handleSubmit()">
		<mat-form-field [appearance]="appearance" [hideRequiredMarker]="hideLabel">
			<mat-label [ngClass]="{ 'cdk-visually-hidden': hideLabel }">
				<ng-content></ng-content>
			</mat-label>
			<input
				type="text"
				matInput
				[maxlength]="maxlength"
				[required]="required"
				[formControlName]="formControlName"
				#autoInp
				#autoTrigger="matAutocompleteTrigger"
				[matAutocomplete]="auto" />
			<ng-container *ngIf="options$ | async as options" matSuffix>
				<button
					*ngIf="control.value && options?.length"
					type="button"
					mat-button
					cm-mini-button
					[disabled]="disabled"
					(click)="clearValue($event, autoTrigger, autoInp)"
					[matTooltip]="clearLoc$ | async"
					[attr.aria-label]="clearLoc$ | async">
					<ats-icon name="close" [size]="12"></ats-icon>
				</button>
			</ng-container>
			<mat-autocomplete
				#auto="matAutocomplete"
				[displayWith]="displayFn"
				autoActiveFirstOption
				autoSelectActiveOption>
				<mat-option *ngFor="let option of filteredOptions$ | async" [value]="option.value">
					{{ option.display }}
				</mat-option>
			</mat-autocomplete>
			<mat-hint align="end">
				<ng-content select="[autocomplete-hints-end]"></ng-content>
			</mat-hint>
			<mat-hint>
				<ng-content select="[autocomplete-hints]"></ng-content>
			</mat-hint>
			<mat-error>
				<ng-content select="[autocomplete-errors]"></ng-content>
			</mat-error>
		</mat-form-field>
	</form>
</ng-container>
